const component = "section-appliances-v2-dialog";

export const sectionAppliancesV2Dialog = {
  component,
  title: `${component}/title`,
  sectionName: `${component}/section-name`,
  applianceCountText: `${component}/appliance-count-text`,
  appliancesTable: {
    table: `${component}/table`,
    noResultText: `${component}/table/no-result-text`,
    searchApplianceInputText: `${component}/table/search-appliance-input-text`,
    applianceCategoryMultiselectFilter: `${component}/table/appliance-category-multiselect-filter`,
    applianceName: `${component}/table/appliance-name`,
    applianceId: `${component}/table/appliance-id`,
    selectAllButton: `${component}/table/select-all-button`,
    unselectAllButton: `${component}/table/unselect-all-button`,
  },
  moveToButton: {
    buton: `${component}/move-to-button`,
    selectCount: `${component}/move-to-button/selected-appliances-count`,
  },
};
